import AuthLayout from "@/layout/auth/AuthLayout.vue";
import MainLayout from "@/layout/main/MainLayout.vue";
import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    component: MainLayout,
    children: [
      {
        path: "/",
        name: "home-default",
        meta: {
          breadcrumb: ["Home"],
          title: "Home",
        },
        component: () => import("@/views/dashboard/HomeView.vue"),
      },
      {
        path: "/dashboard",
        name: "dashboard",
        meta: {
          title: "Dashboard",
        },
        component: () => import("@/views/dashboard/DashboardView.vue"),
      },
      {
        path: "/strategic-house",
        name: "strategic-house",
        meta: {
          breadcrumb: ["Strategy", "Strategic House"],
          title: "Strategic House",
        },
        component: () => import("@/views/strategy/StrategicHouse.vue"),
      },
      {
        path: "/strategy/strategy-map",
        name: "strategy-map",
        meta: {
          breadcrumb: ["Strategy", "Strategy Map"],
          title: "Strategy Map",
        },
        component: () => import("@/views/strategy/StrategyMap.vue"),
      },
      {
        // INI-13/14/15: a strategy's roadmap, initiative list and initiative–KPI linkage
        path: "/strategy/initiative-views",
        name: "initiative-views",
        meta: {
          breadcrumb: ["Strategy", "Initiatives", "Initiative Views"],
          title: "Initiative Views",
          requiresPermission: ["strategic.initiatives.read"],
        },
        component: () => import("@/views/strategy/initiative-portfolio.vue"),
      },
      {
        path: "/initiatives-roadmap",
        name: "initiatives-roadmap",
        meta: {
          breadcrumb: ["Strategy", "Initiatives", "Five-Year Strategy Roadmap"],
          title: "Five-Year Strategy Roadmap",
          requiresPermission: ["strategic.initiatives.read"],
        },
        component: () => import("@/views/strategy/InitiativesRoadmap.vue"),
      },
      {
        path: "/strategy/smo-dashboard",
        name: "smo-dashboard",
        redirect: { name: "pmo-dashboard", query: { tab: "smo" } },
      },
      {
        path: "/project/pmo-dashboard",
        name: "pmo-dashboard",
        meta: {
          breadcrumb: ["Project", "Dashboard"],
          title: "Dashboard",
        },
        component: () => import("@/views/project/PmoDashboard.vue"),
      },
      {
        path: "/project/pmo-library",
        name: "pmo-library",
        meta: {
          breadcrumb: ["Project", "PMO Library"],
          title: "PMO Library",
        },
        component: () => import("@/views/project/pmo-library/index.vue"),
      },
      {
        path: "/project/organizational-structure",
        name: "project-organizational-structure",
        meta: {
          breadcrumb: ["Project", "Org. Structure"],
          title: "Org. Structure",
        },
        component: () => import("@/views/project/organizational-structure.vue"),
      },
      {
        path: "/apps/blog/list",
        name: "blog-list",
        meta: {
          title: "Blog List",
        },
        component: () => import("@/views/apps/blog/List.vue"),
      },
      {
        path: "/apps/blog/detail",
        name: "blog-detail",
        meta: {
          title: "Blog Detail",
        },
        component: () => import("@/views/apps/blog/Detail.vue"),
      },
      {
        path: "/apps/blog/edit",
        name: "blog-edit",
        meta: {
          title: "Blog Edit",
        },
        component: () => import("@/views/apps/blog/Edit.vue"),
      },
      {
        path: "/apps/files",
        name: "files",
        meta: {
          title: "Files",
        },
        component: () => import("@/views/apps/Files.vue"),
      },
      {
        path: "/apps/chat",
        name: "chat",
        meta: {
          title: "Chat",
        },
        component: () => import("@/views/apps/chat/Index.vue"),
      },
      {
        path: "/apps/tasklist",
        name: "tasklist",
        meta: {
          title: "Task List",
        },
        component: () => import("@/views/apps/tasklist/Index.vue"),
      },
      {
        path: "/apps/mail",
        meta: {
          title: "Mail",
        },
        component: () => import("@/views/apps/mail/Index.vue"),
        children: [
          {
            path: "/apps/mail/inbox",
            name: "mail-inbox",
            meta: {
              title: "Inbox",
            },
            component: () => import("@/views/apps/mail/MailTypes.vue"),
          },
          {
            path: "/apps/mail/compose",
            name: "mail-compose",
            meta: {
              title: "Compose",
            },
            component: () => import("@/views/apps/mail/ComposeNew.vue"),
          },
          {
            path: "/apps/mail/detail/:id",
            name: "mail-detail",
            meta: {
              title: "Mail Detail",
            },
            component: () => import("@/views/apps/mail/Detail.vue"),
          },
          {
            path: "/apps/mail/starred",
            name: "mail-starred",
            meta: {
              title: "Starred",
            },
            component: () => import("@/views/apps/mail/MailTypes.vue"),
          },
          {
            path: "/apps/mail/spam",
            name: "mail-spam",
            meta: {
              title: "Spam",
            },
            component: () => import("@/views/apps/mail/MailTypes.vue"),
          },
          {
            path: "/apps/mail/important",
            name: "mail-important",
            meta: {
              title: "Important",
            },
            component: () => import("@/views/apps/mail/MailTypes.vue"),
          },
          {
            path: "/apps/mail/sent",
            name: "mail-sent",
            meta: {
              title: "Sent",
            },
            component: () => import("@/views/apps/mail/MailTypes.vue"),
          },
          {
            path: "/apps/mail/archived",
            name: "mail-archived",
            meta: {
              title: "Archived",
            },
            component: () => import("@/views/apps/mail/MailTypes.vue"),
          },
          {
            path: "/apps/mail/trash",
            name: "mail-trash",
            meta: {
              title: "Trash",
            },
            component: () => import("@/views/apps/mail/MailTypes.vue"),
          },
        ],
      },
      {
        path: "/uikit/formlayout",
        name: "formlayout",
        meta: {
          title: "Form Layout",
        },
        component: () => import("@/views/uikit/FormLayoutDoc.vue"),
      },
      {
        path: "/uikit/input",
        name: "input",
        meta: {
          title: "Input",
        },
        component: () => import("@/views/uikit/InputDoc.vue"),
      },
      {
        path: "/uikit/button",
        name: "button",
        meta: {
          title: "Button",
        },
        component: () => import("@/views/uikit/ButtonDoc.vue"),
      },
      {
        path: "/uikit/table",
        name: "table",
        meta: {
          title: "Table",
        },
        component: () => import("@/views/uikit/TableDoc.vue"),
      },
      {
        path: "/uikit/list",
        name: "list",
        meta: {
          title: "List",
        },
        component: () => import("@/views/uikit/ListDoc.vue"),
      },
      {
        path: "/uikit/tree",
        name: "tree",
        meta: {
          title: "Tree",
        },
        component: () => import("@/views/uikit/TreeDoc.vue"),
      },
      {
        path: "/uikit/panel",
        name: "panel",
        meta: {
          title: "Panel",
        },
        component: () => import("@/views/uikit/PanelsDoc.vue"),
      },

      {
        path: "/uikit/overlay",
        name: "overlay",
        meta: {
          title: "Overlay",
        },
        component: () => import("@/views/uikit/OverlayDoc.vue"),
      },
      {
        path: "/uikit/media",
        name: "media",
        meta: {
          title: "Media",
        },
        component: () => import("@/views/uikit/MediaDoc.vue"),
      },
      {
        path: "/uikit/menu",
        meta: {
          title: "Menu",
        },
        component: () => import("@/views/uikit/MenuDoc.vue"),
      },
      {
        path: "/uikit/message",
        name: "message",
        meta: {
          title: "Message",
        },
        component: () => import("@/views/uikit/MessagesDoc.vue"),
      },
      {
        path: "/uikit/file",
        name: "file",
        meta: {
          title: "File",
        },
        component: () => import("@/views/uikit/FileDoc.vue"),
      },
      {
        path: "/uikit/charts",
        name: "charts",
        meta: {
          title: "Charts",
        },
        component: () => import("@/views/uikit/ChartDoc.vue"),
      },
      {
        path: "/uikit/timeline",
        name: "timeline",
        meta: {
          title: "Timeline",
        },
        component: () => import("@/views/uikit/TimelineDoc.vue"),
      },
      {
        path: "/uikit/misc",
        name: "misc",
        meta: {
          title: "Misc",
        },
        component: () => import("@/views/uikit/MiscDoc.vue"),
      },
      {
        path: "/pages/empty",
        name: "empty",
        component: () => import("@/views/pages/Empty.vue"),
      },
      {
        path: "/pages/crud",
        name: "crud",
        component: () => import("@/views/pages/Crud.vue"),
      },
      {
        path: "/profile/settings",
        name: "profile-settings",
        meta: {
          breadcrumb: ["Profile", "Settings"],
          title: "Profile Settings",
        },
        component: () => import("@/views/pages/ProfileSettings.vue"),
      },
      {
        path: "/profile/create",
        name: "user-create",
        meta: {
          breadcrumb: ["Settings", "Create User"],
          title: "Create User",
          requiresRole: ["Super Admin"],
        },
        component: () => import("@/views/user-management/UserCreate.vue"),
      },
      {
        path: "/profile/list",
        name: "user-list",
        meta: {
          breadcrumb: ["Settings", "Users"],
          title: "User List",
          requiresRole: ["Super Admin"],
        },
        component: () => import("@/views/user-management/users.vue"),
      },
      {
        path: "/roles",
        name: "roles",
        meta: {
          breadcrumb: ["Settings", "Roles"],
          title: "Roles",
          requiresRole: ["Super Admin"],
        },
        component: () => import("@/views/user-management/roles.vue"),
      },
      {
        path: "/permissions",
        name: "permissions",
        meta: {
          breadcrumb: ["Settings", "Permissions"],
          title: "Permissions",
          requiresRole: ["Super Admin"],
        },
        component: () => import("@/views/user-management/permissions.vue"),
      },
      {
        path: "/departments",
        name: "departments",
        meta: {
          breadcrumb: ["Settings", "Departments"],
          title: "Departments",
          requiresRole: ["Super Admin"],
        },
        component: () => import("@/views/user-management/departments.vue"),
      },
      {
        path: "/divisions",
        name: "divisions",
        meta: {
          breadcrumb: ["Settings", "Divisions"],
          title: "Divisions",
          requiresRole: ["Super Admin"],
        },
        component: () => import("@/views/user-management/divisions.vue"),
      },
      {
        path: "/data-import",
        name: "data-import",
        meta: {
          breadcrumb: ["Settings", "Data Import"],
          title: "Data Import",
          requiresRole: ["Super Admin"],
        },
        component: () => import("@/views/user-management/DataImport.vue"),
      },
      {
        path: "/knowledge-hub",
        name: "knowledge-hub",
        meta: {
          breadcrumb: ["Knowledge Hub"],
          title: "Knowledge Hub",
        },
        component: () => import("@/views/knowledge/KnowledgeHub.vue"),
      },
      // Project Management Routes
      {
        path: "/project/home",
        name: "project-home",
        meta: {
          breadcrumb: ["Project", "Home"],
          title: "Project Home",
        },
        component: () => import("@/views/project/home.vue"),
      },
      {
        path: "/project/dashboard",
        name: "project-dashboard",
        meta: {
          breadcrumb: ["Project", "Dashboard"],
          title: "Project Dashboard",
        },
        component: () => import("@/views/project/dashboard.vue"),
      },
      {
        path: "/project/projects",
        name: "projects",
        meta: {
          breadcrumb: ["Project", "Projects"],
          title: "Projects",
        },
        component: () => import("@/views/project/projects.vue"),
      },
      {
        path: "/project/tasks",
        name: "project-tasks",
        meta: {
          breadcrumb: ["Project Management", "Tasks"],
          title: "Task Management",
        },
        component: () => import("@/views/project/task-management/tasks.vue"),
      },
      {
        path: "/project/project/create",
        name: "project-create",
        meta: {
          breadcrumb: ["Project", "Create Project"],
          title: "Create Project",
        },
        component: () => import("@/views/project/project/create.vue"),
      },
      {
        path: "/project/project/:id/review",
        name: "project-review",
        meta: {
          breadcrumb: ["Project", "Review Project"],
          title: "Review Project",
        },
        component: () => import("@/views/project/project/review.vue"),
      },
      {
        path: "/project/project/:id",
        name: "project-detail",
        meta: {
          breadcrumb: ["Project", "Project Detail"],
          title: "Project Detail",
        },
        component: () => import("@/views/project/project/[id].vue"),
      },
      // Program Routes
      {
        path: "/project/programs",
        name: "programs",
        meta: {
          breadcrumb: ["Project", "Programs"],
          title: "Programs",
        },
        component: () => import("@/views/project/program/programs.vue"),
      },
      {
        path: "/project/program/create",
        name: "program-create",
        meta: {
          breadcrumb: ["Project", "Create Program"],
          title: "Create Program",
        },
        component: () => import("@/views/project/program/create.vue"),
      },
      {
        path: "/project/program/:id/review",
        name: "program-review",
        meta: {
          breadcrumb: ["Project", "Review Program"],
          title: "Review Program",
        },
        component: () => import("@/views/project/program/review.vue"),
      },
      {
        path: "/project/program/:id",
        name: "program-detail",
        meta: {
          breadcrumb: ["Project", "Program Detail"],
          title: "Program Detail",
        },
        component: () => import("@/views/project/program/[id].vue"),
      },
      // Portfolio Routes
      {
        path: "/portfolio",
        name: "portfolios",
        meta: {
          breadcrumb: ["Portfolio", "Portfolios"],
          title: "Portfolios",
        },
        component: () => import("@/views/portfolio/portfolios.vue"),
      },
      {
        path: "/portfolio/create",
        name: "portfolio-create",
        meta: {
          breadcrumb: ["Portfolio", "Create Portfolio"],
          title: "Create Portfolio",
        },
        component: () => import("@/views/portfolio/create.vue"),
      },
      {
        path: "/portfolio/:id/review",
        name: "portfolio-review",
        meta: {
          breadcrumb: ["Portfolio", "Review Portfolio"],
          title: "Review Portfolio",
        },
        component: () => import("@/views/portfolio/review.vue"),
      },
      {
        path: "/portfolio/:id",
        name: "portfolio-detail",
        meta: {
          breadcrumb: ["Portfolio", "Portfolio Detail"],
          title: "Portfolio Detail",
        },
        component: () => import("@/views/portfolio/[id].vue"),
      },
      {
        path: "/documentation",
        name: "documentation",
        meta: {
          title: "Documentation",
        },
        component: () => import("@/views/utilities/Documentation.vue"),
      },
      {
        path: "/strategy/strategic-plans",
        name: "strategic-plans",
        meta: {
          breadcrumb: ["Strategy", "Strategic Plans"],
          title: "Strategic Plans",
        },
        component: () => import("@/views/strategy/strategic-plans.vue"),
      },
      {
        path: "/strategy/annual-business-plan",
        name: "annual-business-plan",
        meta: {
          breadcrumb: ["Annual Plan", "Division Plans"],
          title: "Division Plans",
        },
        component: () =>
          import("@/views/strategy/annual-business-plan/departments.vue"),
      },
      {
        // The SMO assigns initiative projects and OPIs to departments,
        // styled to feel like the Division Plans page beside it.
        path: "/strategy/annual-business-plan/department-assignment",
        name: "department-assignment",
        meta: {
          breadcrumb: ["Annual Plan", "Department Assignment"],
          title: "Department Assignment",
          requiresPermission: ["annual-business-plans.manage"],
        },
        component: () =>
          import(
            "@/views/strategy/annual-business-plan/department-assignment.vue"
          ),
      },
      {
        // OPIs, department activities and the complete annual-plan register.
        path: "/strategy/annual-business-plan/list",
        name: "annual-business-plan-list",
        meta: {
          breadcrumb: ["Annual Plan", "Annual Business Plan"],
          title: "Annual Business Plan",
        },
        component: () =>
          import("@/views/strategy/annual-business-plan/workspace.vue"),
      },
      {
        path: "/library",
        name: "istedama-library",
        meta: {
          breadcrumb: ["Istedama Library"],
          title: "Istedama Library",
        },
        component: () => import("@/views/library/index.vue"),
      },
      {
        path: "/master-plan/project/:id",
        name: "master-plan-project-card",
        meta: {
          breadcrumb: ["Master Plan", "Update Project Card"],
          title: "Update Project Card",
        },
        component: () =>
          import("@/views/strategy/master-plan/project-card.vue"),
      },
      {
        path: "/master-plan",
        name: "master-plan",
        meta: {
          breadcrumb: ["Master Plan", "Master Plan"],
          title: "Master Plan",
        },
        component: () => import("@/views/strategy/MasterPlan.vue"),
      },
      {
        path: "/master-plan/:id/edit",
        name: "master-plan-edit",
        meta: {
          breadcrumb: ["Master Plan", "Master Plan", "Details"],
          title: "Master Plan Details",
        },
        component: () => import("@/views/strategy/master-plan/edit.vue"),
      },
      {
        path: "/project-management",
        alias: "/plan-management",
        name: "plan-management",
        meta: {
          breadcrumb: ["Projects"],
          title: "Projects",
        },
        component: () => import("@/views/strategy/plan-management/index.vue"),
      },
      {
        path: "/project-management/:id",
        alias: ["/plan-management/:id", "/master-plan/:id/workspace"],
        name: "plan-detail",
        meta: {
          breadcrumb: ["Projects", "Project Details"],
          title: "Project Details",
        },
        component: () => import("@/views/strategy/master-plan/workspace.vue"),
      },
      {
        path: "/master-plan/:id",
        name: "master-plan-detail",
        meta: {
          breadcrumb: ["Master Plan", "Master Plan", "Details"],
          title: "Master Plan",
        },
        component: () =>
          import("@/views/strategy/annual-business-plan/[id].vue"),
      },
      {
        path: "/strategy/annual-business-plan/plan/create",
        name: "annual-business-plan-create",
        meta: {
          breadcrumb: ["Annual Plan", "Annual Business Plan", "Create"],
          title: "Create Annual Business Plan",
        },
        component: () =>
          import("@/views/strategy/annual-business-plan/create.vue"),
      },
      {
        path: "/strategy/annual-business-plan/:id/edit",
        name: "annual-business-plan-edit",
        meta: {
          breadcrumb: ["Annual Plan", "Annual Business Plan", "Edit"],
          title: "Edit Annual Business Plan",
        },
        component: () =>
          import("@/views/strategy/annual-business-plan/create.vue"),
      },
      {
        path: "/strategy/annual-business-plan/:id",
        name: "annual-business-plan-detail",
        meta: {
          breadcrumb: ["Annual Plan", "Annual Business Plan", "Details"],
          title: "Annual Business Plan",
        },
        component: () =>
          import("@/views/strategy/annual-business-plan/[id].vue"),
      },
      {
        path: "/strategy/strategic-plan/create",
        name: "strategic-plan-create",
        meta: {
          breadcrumb: ["Strategy", "Strategic Plans", "Create"],
          title: "Create Strategic Plan",
        },
        component: () => import("@/views/strategy/strategic-plan/create.vue"),
      },
      {
        path: "/strategy/strategic-plan/:id",
        name: "strategic-plan-detail",
        meta: {
          breadcrumb: ["Strategy", "Strategic Plans", "Details"],
          title: "Strategy Details",
        },
        component: () => import("@/views/strategy/strategic-plan/[id].vue"),
      },
      {
        path: "/strategy/strategic-plan/:id/edit",
        name: "strategic-plan-edit",
        meta: {
          breadcrumb: ["Strategy", "Strategic Plans", "Edit"],
          title: "Edit Strategic Plan",
        },
        component: () => import("@/views/strategy/strategic-plan/create.vue"),
      },
      // ── Strategic KPIs ──
      {
        path: "/strategy/strategic-kpis",
        name: "strategic-kpis",
        meta: {
          breadcrumb: ["Strategy", "Strategic KPIs"],
          title: "Strategic KPIs",
        },
        component: () => import("@/views/strategy/strategic-kpis.vue"),
      },
      {
        path: "/strategy/opi-settings",
        name: "opi-settings",
        meta: {
          breadcrumb: ["Strategy", "OPI Scoring"],
          title: "OPI Scoring",
        },
        component: () => import("@/views/strategy/opi-settings.vue"),
      },
      {
        path: "/strategy/opis/:id",
        name: "opi-detail",
        meta: {
          breadcrumb: ["Strategy", "OPIs", "Details"],
          title: "OPI Details",
        },
        component: () => import("@/views/strategy/opi/[id].vue"),
      },
      {
        path: "/strategy/strategic-kpis/create",
        name: "strategic-kpi-create",
        meta: {
          breadcrumb: ["Strategy", "Strategic KPIs", "Create"],
          title: "Create Strategic KPI",
        },
        component: () =>
          import("@/views/strategy/strategic-kpi/kpi-definition.vue"),
      },
      {
        path: "/strategy/strategic-kpis/:id",
        name: "strategic-kpi-detail",
        meta: {
          breadcrumb: ["Strategy", "Strategic KPIs", "Details"],
          title: "KPI Details",
        },
        component: () => import("@/views/strategy/strategic-kpi/[id].vue"),
      },
      {
        path: "/strategy/strategic-kpis/:id/edit",
        name: "strategic-kpi-edit",
        meta: {
          breadcrumb: ["Strategy", "Strategic KPIs", "Edit"],
          title: "Edit Strategic KPI",
        },
        component: () =>
          import("@/views/strategy/strategic-kpi/kpi-definition.vue"),
      },
      {
        path: "/strategy/strategic-kpis/:id/review",
        name: "strategic-kpi-review",
        meta: {
          breadcrumb: ["Strategy", "Strategic KPIs", "Review"],
          title: "Review Strategic KPI",
        },
        component: () =>
          import("@/views/strategy/strategic-kpi/kpi-review.vue"),
      },
      {
        path: "/strategy/kpi-change-requests",
        name: "kpi-change-requests",
        meta: {
          breadcrumb: ["Strategy", "KPI Change Requests"],
          title: "KPI Change Requests",
        },
        component: () =>
          import("@/views/strategy/kpi-change-requests/index.vue"),
      },
      {
        path: "/strategy/kpi-change-requests/create",
        name: "kpi-change-request-create",
        meta: {
          breadcrumb: ["Strategy", "KPI Change Requests", "Create"],
          title: "Create KPI Change Request",
        },
        component: () => import("@/views/strategy/strategic-kpi/create.vue"),
      },
      {
        path: "/strategy/kpi-change-requests/:id",
        name: "kpi-change-request-detail",
        meta: {
          breadcrumb: ["Strategy", "KPI Change Requests", "Details"],
          title: "KPI Change Request Details",
        },
        component: () => import("@/views/strategy/strategic-kpi/review.vue"),
      },
      {
        path: "/strategy/kpi-change-requests/:id/edit",
        name: "kpi-change-request-edit",
        meta: {
          breadcrumb: ["Strategy", "KPI Change Requests", "Edit"],
          title: "Edit KPI Change Request",
        },
        component: () => import("@/views/strategy/strategic-kpi/create.vue"),
      },
      {
        path: "/strategy/kpi-measurements/:kpiId/update",
        name: "kpi-measurement-update",
        meta: {
          breadcrumb: [
            "Strategy",
            "Update Strategic KPI",
            "Measurement Update",
          ],
          title: "KPI Measurement Update",
        },
        component: () => import("@/views/strategy/kpi-measurements/update.vue"),
      },
      {
        path: "/strategy/kpi-measurements/:id/review",
        name: "kpi-measurement-review",
        meta: {
          breadcrumb: ["Strategy", "Update Strategic KPI", "Review"],
          title: "Review KPI Measurement",
        },
        component: () => import("@/views/strategy/kpi-measurements/review.vue"),
      },
      // Initiative Routes
      {
        path: "/strategy/initiative/:id/projects",
        name: "initiative-projects",
        meta: {
          breadcrumb: ["Strategy", "Initiatives", "Projects"],
          title: "Initiative Projects",
        },
        component: () => import("@/views/strategy/initiative/projects.vue"),
      },
      {
        path: "/strategy/initiatives",
        name: "initiatives",
        meta: {
          breadcrumb: ["Strategy", "Initiatives"],
          title: "Initiatives",
        },
        component: () => import("@/views/strategy/initiatives.vue"),
      },
      {
        path: "/strategy/initiatives/create",
        name: "initiative-create",
        meta: {
          breadcrumb: ["Strategy", "Initiatives", "Create"],
          title: "Create Initiative",
        },
        component: () => import("@/views/strategy/initiative/create.vue"),
      },
      {
        // The initiative card page is retired: everything it showed now
        // lives in the Manage Initiative workspace (Overview tab). The
        // route redirects so existing links and bookmarks still land
        // somewhere useful instead of 404ing.
        // To bring the card page back, restore the component line below.
        path: "/strategy/initiatives/:id",
        name: "initiative-detail",
        redirect: (to) => ({
          path: `/strategy/initiatives/${to.params.id}/manage`,
          query: to.query,
        }),
        // meta: {
        //     breadcrumb: ['Strategy', 'Initiatives', 'Details'],
        //     title: 'Initiative Details'
        // },
        // component: () => import('@/views/strategy/initiative/[id].vue')
      },
      {
        // INI-07: the initiative workspace — KPIs, Projects, Change Requests
        path: "/strategy/initiatives/:id/manage",
        name: "initiative-manage",
        meta: {
          breadcrumb: ["Strategy", "Initiatives", "Manage"],
          title: "Manage Initiative",
        },
        component: () => import("@/views/strategy/initiative/manage.vue"),
      },
      {
        path: "/strategy/initiatives/:id/edit",
        name: "initiative-edit",
        meta: {
          breadcrumb: ["Strategy", "Initiatives", "Edit"],
          title: "Edit Initiative",
        },
        component: () => import("@/views/strategy/initiative/create.vue"),
      },
      {
        path: "/strategy/initiatives/:id/review",
        name: "initiative-review",
        meta: {
          breadcrumb: ["Strategy", "Initiatives", "Review"],
          title: "Review Initiative",
        },
        component: () => import("@/views/strategy/initiative/review.vue"),
      },
      {
        path: "/strategy/initiatives/:id/update",
        name: "initiative-update",
        meta: {
          breadcrumb: ["Strategy", "Initiatives", "Update"],
          title: "Update Initiative",
        },
        component: () =>
          import("@/views/strategy/initiative/update/update.vue"),
      },
      {
        path: "/strategy/initiatives/:id/review-update",
        name: "initiative-review-update",
        meta: {
          breadcrumb: ["Strategy", "Initiatives", "Review Update"],
          title: "Review Initiative Update",
        },
        component: () =>
          import("@/views/strategy/initiative/update/review.vue"),
      },
      {
        path: "/strategy/initiatives/:id/closure",
        name: "initiative-closure",
        meta: {
          breadcrumb: ["Strategy", "Initiatives", "Closure"],
          title: "Initiative Closure",
        },
        component: () =>
          import("@/views/strategy/initiative/closure/create.vue"),
      },
      {
        path: "/strategy/initiatives/:id/review-closure",
        name: "initiative-review-closure",
        meta: {
          breadcrumb: ["Strategy", "Initiatives", "Review Closure"],
          title: "Review Initiative Closure",
        },
        component: () =>
          import("@/views/strategy/initiative/closure/review.vue"),
      },
      {
        path: "/strategy/initiatives-update",
        name: "initiatives-update-list",
        meta: {
          breadcrumb: ["Strategy", "Initiative Updates"],
          title: "Initiative Updates",
        },
        component: () => import("@/views/strategy/initiative/update/list.vue"),
      },
      {
        path: "/strategy/audit-log",
        name: "audit-log",
        meta: {
          breadcrumb: ["Settings", "Audit Log"],
          title: "Audit Log",
        },
        component: () => import("@/views/strategy/audit-log.vue"),
      },
      {
        path: "/strategy/annual-plans/:id/versions",
        name: "annual-plan-versions",
        meta: {
          breadcrumb: ["Strategy", "Plan Versions"],
          title: "Plan Versions",
        },
        component: () => import("@/views/strategy/annual-plan-versions.vue"),
      },
      {
        path: "/strategy/my-tasks",
        name: "my-tasks",
        meta: {
          breadcrumb: ["Strategy", "My Tasks"],
          title: "My Tasks",
        },
        component: () => import("@/views/strategy/my-tasks.vue"),
      },
      {
        path: "/strategy/initiatives-closure",
        name: "initiatives-closure-list",
        meta: {
          breadcrumb: ["Strategy", "Initiative Closures"],
          title: "Initiative Closures",
        },
        component: () => import("@/views/strategy/initiative/closure/list.vue"),
      },
      // Corrective Plan Routes
      {
        path: "/strategy/corrective-plans",
        name: "corrective-plans",
        meta: {
          breadcrumb: ["Strategy", "Corrective Plans"],
          title: "Corrective Plans",
        },
        component: () => import("@/views/strategy/corrective-plan-list.vue"),
      },
      {
        path: "/strategy/corrective-plans/create",
        name: "corrective-plan-create",
        meta: {
          breadcrumb: ["Strategy", "Corrective Plans", "Create"],
          title: "Create Corrective Plan",
        },
        component: () => import("@/views/strategy/corrective-plan-create.vue"),
      },
      {
        path: "/strategy/corrective-plans/:id",
        name: "corrective-plan-detail",
        meta: {
          breadcrumb: ["Strategy", "Corrective Plans", "Details"],
          title: "Corrective Plan Details",
        },
        component: () => import("@/views/strategy/corrective-plan-detail.vue"),
      },
      {
        path: "/strategy/corrective-plans/:id/edit",
        name: "corrective-plan-edit",
        meta: {
          breadcrumb: ["Strategy", "Corrective Plans", "Edit"],
          title: "Edit Corrective Plan",
        },
        component: () => import("@/views/strategy/corrective-plan-create.vue"),
      },
      {
        path: "/strategy/corrective-plans/:id/review",
        name: "corrective-plan-review",
        meta: {
          breadcrumb: ["Strategy", "Corrective Plans", "Review"],
          title: "Review Corrective Plan",
        },
        component: () => import("@/views/strategy/corrective-plan-detail.vue"),
      },
      // Strategic Risk Routes
      {
        path: "/strategy/risks",
        name: "strategy-risks",
        meta: {
          breadcrumb: ["Strategy", "Risks"],
          title: "Strategic Risks",
        },
        component: () => import("@/views/strategy/risk-list.vue"),
      },
      {
        path: "/strategy/risks/create",
        name: "strategy-risk-create",
        meta: {
          breadcrumb: ["Strategy", "Risks", "Create"],
          title: "Create Strategic Risk",
        },
        component: () => import("@/views/strategy/risk-create.vue"),
      },
      {
        path: "/strategy/risks/:id",
        name: "strategy-risk-detail",
        meta: {
          breadcrumb: ["Strategy", "Risks", "Details"],
          title: "Strategic Risk Details",
        },
        component: () => import("@/views/strategy/risk-detail.vue"),
      },
      {
        path: "/strategy/risks/:id/edit",
        name: "strategy-risk-edit",
        meta: {
          breadcrumb: ["Strategy", "Risks", "Edit"],
          title: "Edit Strategic Risk",
        },
        component: () => import("@/views/strategy/risk-create.vue"),
      },
      {
        path: "/strategy/risks/:id/review",
        name: "strategy-risk-review",
        meta: {
          breadcrumb: ["Strategy", "Risks", "Review"],
          title: "Review Strategic Risk",
        },
        component: () => import("@/views/strategy/risk-detail.vue"),
      },
      // Strategic Challenge Routes
      {
        path: "/strategy/challenges",
        name: "strategy-challenges",
        meta: {
          breadcrumb: ["Strategy", "Challenges"],
          title: "Strategic Challenges",
        },
        component: () => import("@/views/strategy/challenge-list.vue"),
      },
      {
        path: "/strategy/challenges/create",
        name: "strategy-challenge-create",
        meta: {
          breadcrumb: ["Strategy", "Challenges", "Create"],
          title: "Create Strategic Challenge",
        },
        component: () => import("@/views/strategy/challenge-create.vue"),
      },
      {
        path: "/strategy/challenges/:id",
        name: "strategy-challenge-detail",
        meta: {
          breadcrumb: ["Strategy", "Challenges", "Details"],
          title: "Strategic Challenge Details",
        },
        component: () => import("@/views/strategy/challenge-detail.vue"),
      },
      {
        path: "/strategy/challenges/:id/edit",
        name: "strategy-challenge-edit",
        meta: {
          breadcrumb: ["Strategy", "Challenges", "Edit"],
          title: "Edit Strategic Challenge",
        },
        component: () => import("@/views/strategy/challenge-create.vue"),
      },
      {
        path: "/strategy/challenges/:id/review",
        name: "strategy-challenge-review",
        meta: {
          breadcrumb: ["Strategy", "Challenges", "Review"],
          title: "Review Strategic Challenge",
        },
        component: () => import("@/views/strategy/challenge-detail.vue"),
      },
      // Initiative Change Request Routes
      {
        path: "/strategy/initiative-change-requests",
        name: "initiative-change-requests",
        meta: {
          breadcrumb: ["Strategy", "Initiative Change Requests"],
          title: "Initiative Change Requests",
        },
        component: () =>
          import("@/views/strategy/initiative/change-request/list.vue"),
      },
      {
        path: "/strategy/initiative-change-requests/create",
        name: "initiative-change-request-create",
        meta: {
          breadcrumb: ["Strategy", "Initiative Change Requests", "Create"],
          title: "Create Initiative Change Request",
        },
        component: () =>
          import("@/views/strategy/initiative/change-request/create.vue"),
      },
      {
        path: "/strategy/initiative-change-requests/:id",
        name: "initiative-change-request-detail",
        meta: {
          breadcrumb: ["Strategy", "Initiative Change Requests", "Details"],
          title: "Initiative Change Request Details",
        },
        component: () =>
          import("@/views/strategy/initiative/change-request/detail.vue"),
      },
      {
        path: "/strategy/initiative-change-requests/:id/edit",
        name: "initiative-change-request-edit",
        meta: {
          breadcrumb: ["Strategy", "Initiative Change Requests", "Edit"],
          title: "Edit Initiative Change Request",
        },
        component: () =>
          import("@/views/strategy/initiative/change-request/create.vue"),
      },
      {
        path: "/strategy/initiative-change-requests/:id/review",
        name: "initiative-change-request-review",
        meta: {
          breadcrumb: ["Strategy", "Initiative Change Requests", "Review"],
          title: "Review Initiative Change Request",
        },
        component: () =>
          import("@/views/strategy/initiative/change-request/review.vue"),
      },
      {
        path: "/notifications",
        name: "notifications",
        meta: {
          breadcrumb: ["Notifications"],
          title: "Notifications",
        },
        component: () => import("@/views/notifications/AllNotifications.vue"),
      },
      {
        path: "/pages/aboutus",
        name: "aboutus",
        meta: {
          title: "About Us",
        },
        component: () => import("@/views/pages/AboutUs.vue"),
      },
      {
        path: "/pages/faq",
        name: "faq",
        meta: {
          title: "FAQ",
        },
        component: () => import("@/views/pages/Faq.vue"),
      },
      {
        path: "/pages/help",
        name: "help",
        meta: {
          title: "Help",
        },
        component: () => import("@/views/pages/Help.vue"),
      },
      {
        path: "/pages/invoice",
        name: "invoice",
        meta: {
          title: "Invoice",
        },
        component: () => import("@/views/pages/Invoice.vue"),
      },
    ],
  },
  {
    path: "/auth",
    component: AuthLayout,
    children: [
      {
        path: "login",
        name: "login",
        component: () => import("@/views/system/LoginView.vue"),
      },
      {
        path: "sso/callback",
        name: "sso-callback",
        component: () => import("@/views/system/SsoCallbackView.vue"),
      },
      {
        path: "register",
        name: "register",
        component: () => import("@/views/system/RegisterView.vue"),
      },
      {
        path: "forgot-password",
        name: "forgot-password",
        component: () => import("@/views/system/ForgotPasswordView.vue"),
      },
      {
        path: "lock-screen",
        name: "lock-screen",
        component: () => import("@/views/system/ScreenLockedView.vue"),
      },
      {
        path: "new-password",
        name: "new-password",
        component: () => import("@/views/system/CreateNewPasswordView.vue"),
      },
      {
        path: "verification",
        name: "verification",
        component: () => import("@/views/system/VerificationView.vue"),
      },
      {
        path: "oops",
        name: "oops",
        component: () => import("@/views/system/OopsView.vue"),
      },
      {
        path: "access-denied",
        name: "access-denied",
        component: () => import("@/views/system/AccessDeniedView.vue"),
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    name: "notfound-layout",
    component: AuthLayout,
    children: [
      {
        path: "",
        name: "notfound",
        component: () => import("@/views/system/404View.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { left: 0, top: 0 };
  },
});

export default router;
